import { storefrontSlice } from '../slices/storefrontSlice';

export default storefrontSlice.reducer;
